import i18next from "i18next";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getLocalStorageItem } from "../helper/localStorageHelper";
import { getCustomEntityData } from "../utils/ApiHandler";
import { ENUM_EVENT } from "../utils/eventEmitter";
import { syncCustomEntityMenu } from "../helper/customEntityMenu";

const EDM_PATH_PREFIX = "/edm";

const useCustomEntitySync = () => {
  const location = useLocation();
  // Only fetch the custom entity list while the user is inside the EDM module.
  const isEdmModule = location?.pathname?.startsWith(EDM_PATH_PREFIX);

  const fetchAndUpdate = async () => {
    const user = getLocalStorageItem("user");
    const bu = getLocalStorageItem("selected_business_unit");
    const tenant_id = user?.tenant_id;
    if (!tenant_id) return;

    const bu_id = bu?.business_unit_id ?? "";
    const entities = await getCustomEntityData(tenant_id, bu_id);
    if (!Array.isArray(entities)) return;

    syncCustomEntityMenu();

    globalThis.dispatchEvent(new Event(ENUM_EVENT.CUSTOM_ENTITY_UPDATED));
  };

  // Fetch when entering the EDM module (fires once per entry; navigating
  // between EDM sub-pages keeps isEdmModule true, so no extra calls).
  useEffect(() => {
    if (isEdmModule) fetchAndUpdate();
  }, [isEdmModule]);

  // Refetch on language change so BE-provided display names are re-translated,
  // but only while the user is still on the EDM module.
  useEffect(() => {
    const handleLanguageChange = () => {
      if (isEdmModule) fetchAndUpdate();
    };

    i18next.on("languageChanged", handleLanguageChange);
    return () => {
      i18next.off("languageChanged", handleLanguageChange);
    };
  }, [isEdmModule]);
};

export default useCustomEntitySync;
